<template>
    <el-header height="">
        <div class="layer-hander">
            <i v-if="showBtn" class="iconfont icon-caidan menu-btn" @click="showSidebar"></i>
            <div class="hander-title" @click="jumpToHomeHandle">
                <img src="@/assets/images/logo5.png" alt="">
                <a class="website-name">慈脉藏书阁</a>
            </div>
            <div class="hander-content">
                <div class="search">
                    <el-input v-if="!notHasSearch" size="small" placeholder="搜索" v-model="keyword" clearable @clear="onSearch"
                        @keyup.enter.native="onSearch">
                        <el-button @click="onSearch" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-radio-group v-if="!isDrugPage && !notHasSearch" v-model="searchType" @change="onSearch">
                        <el-radio v-for="item in searchTypeList" :key="item.value" :label="item.value">
                            {{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </div>
                <down-menu class="sj" />
                <u-switch class="pc" v-model="mk_isDark" @change="darkChange"></u-switch>
                <el-menu :default-active="activeIndex" class="el-menu-demo pc" mode="horizontal" @select="handleSelect">
                    <!-- <el-menu-item index="1">首页</el-menu-item> -->
                    <el-menu-item class="menu-item" index="2">中药材</el-menu-item>
                    <el-menu-item class="menu-item" index="3">中医书籍</el-menu-item>
                    <el-menu-item class="menu-item" index="5">医学文章</el-menu-item>
                    <el-menu-item v-if="Number(exUserInfo.type) !== 1" class="menu-item" index="4">慈脉ChatGPT</el-menu-item>
                </el-menu>
                <el-dropdown class="pc user-el-dropdown" @command="onDropdown">
                    <span class="el-dropdown-link">
                        <el-image class="user-avatar" :src="userAvatar"></el-image>
                        <span class="user-name oneline">{{ exUserInfo.employeeName? exUserInfo.employeeName:userInfo.employeeName}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="user-dropdown">
                        <div v-if="Number(exUserInfo.type) === 1">
                            <div class="dropdown-user-info clearfix">
                                <el-image class="user-avatar" :src="userAvatar"></el-image>
                                <span class="user-name">{{ exUserInfo.employeeName? exUserInfo.employeeName:userInfo.employeeName }}</span>
                            </div>
                            <div class="dropdown-fortune"><span class="num">{{ exUserInfo.integral}}</span>福报值</div>
                            <el-dropdown-item command="personalData" :class="routerName === '/personalData'?'dropdown-active':''">
                                <i class="el-icon-user user-icon"></i>个人信息
                            </el-dropdown-item>
                            <el-dropdown-item command="fortuneTask" :class="routerName === '/fortuneTask'?'dropdown-active':''">
                                <i class="el-icon-document-checked user-icon"></i>福报任务<i v-if="exUserInfo.redDot" class="dot"></i></el-dropdown-item>
                        </div>
                        <el-dropdown-item command="quit"><i class="exit-icon user-icon"></i>退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </el-header>
</template>

<script>
import DownMenu from '@/components/downMenu.vue';
import USwitch from '@/components/uSwitch.vue';
import { mapGetters } from 'vuex';
export default {
    components: { DownMenu, USwitch },
    computed: {
        ...mapGetters(['isDark', 'userInfo','exUserInfo']),
        showBtn() {
            return this.$route.name == 'bookDetail'
        },
        activeIndex() {
            let arr = [
                [],
                ["index"],
                ["pageSearch", "drugDetail"],
                ["pageBook", "pageCatalogue", "bookDetail"],
                ["chatGpt"],
                ["pageArticle","articleDetail"],
            ]
            let index = arr.findIndex(i => i.includes(this.$route.name));
            return index > -1 ? index + "" : "0";
            // return ["pageSearch", "drugDetail"].includes(this.$route.name) ? "2" : "3"
        },
        // 是否药品页面
        isDrugPage() {
            return this.pageNames.includes(this.$route.name);
        },
        notHasSearch() {
            return this.pageOtherName.includes(this.$route.name);
        },
    },
    watch: {
        isDark() {
            this.mk_isDark = this.isDark
        },
        '$route'() {
            // 监听路由变化
            this.routerName = this.$route.path
        }
    },
    data() {
        return {
            userAvatar: require('@/assets/images/avatar.png'),
            pageNames: [
                "pageSearch",
                "drugDetail",
            ],
            pageOtherName: [
                'pageArticle',
                'articleDetail',
                'personalData',
                'fortuneTask',
                'chatGpt',
                'home'
            ],
            mk_isDark: false,
            keyword: "",
            searchType: 1, //1 内容检索 2 书名检索
            searchTypeList: [
                { label: "按内容", value: 1 },
                { label: "按书名", value: 2 }
            ],
            routerName: '',
        }
    },
    methods: {
        jumpToHomeHandle(){
            this.jump('/')
        },
        darkChange() {
            this.$store.commit("setIsDark", this.mk_isDark);
        },
        onSearch() {
            if (this.isDrugPage) {
                this.jump('/pageSearch/' + this.keyword)
            } else {
                // this.jump('/pageBook/' + this.keyword)
                let key =  this.keyword.trim()
                if (key) {
                    this.jump(`/pageBook/keyword=${key}&searchtype=${this.searchType}`)
                } else {
                    this.jump(`/pageBook`)
                }
            }
        },
        showSidebar() {
            this.$store.commit('setSidebarShow', true);
        },
        handleSelect(name) {
            switch (name) {
                case "1":
                    this.jump("/home")
                    break;
                case "2":
                    this.jump("/pageSearch")
                    break;
                case "3":
                    this.jump("/pageBook")
                    break;
                case "4":
                    this.jump("/chatGpt")
                    break;
                case "5":
                    this.jump("/pageArticle")
                    break;
                default:
                    break;
            }
        },
        onDropdown(name) {
            switch (name) {
                case 'personalData':
                    this.jump("/personalData")
                    break;
                case 'fortuneTask':
                    this.jump("/fortuneTask")
                    break;
                case 'quit':
                    this.$store.commit("logout")
                    break;
            }
        }
    },
    created() {
        this.mk_isDark = this.isDark;
    },
}
</script>

<style lang="scss" scoped>
.website-name{
    &:hover{
        color: #000 !important;
    }
}
.menu-item{
    padding: 0 10px;
}
.layer-hander {
    .el-icon-search {
        cursor: pointer;
    }

    .u-switch {
        margin-right: 30px;
    }
}

.search {
    display: flex !important;
    align-items: center;

    .el-input {
        width: 200px;
        margin-right: 10px;
    }


    .el-radio-group {
        display: inline;

        .el-radio {
            margin-right: 10px;
        }

        :deep {
            .el-radio__label {
                padding-left: 0px
            }
        }

    }
}
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}
.user-el-dropdown{
    padding: 0 !important;
    line-height: 55px;
}

.el-dropdown-link{
    display: inline-block;
    width: 180px;
    .user-avatar{
        float: left;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin: 7px;
    }
    .user-name{
        float: left;
        margin-left: 5px;
    }
}
.oneline{
    max-width:80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.user-dropdown{
    display: blocks;
    width: 300px;
    border-radius: 10px;
    // box-shadow: rgba(61, 61, 61, 0.4) 0px 2px 6px 2px;
    background: rgb(255, 255, 255);
    font-size: 18px;
    .dropdown-user-info{
        position: relative;
        height: 55px;
        margin-bottom: 20px;
        padding: 0 20px;
        .user-avatar{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 15px;
        }
        .user-name{
            overflow: hidden;
            display: inline-block;
            width: 190px;
            line-height: 45px;
            max-width: 190px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .dropdown-fortune{
        padding: 0 20px 20px;
        border-bottom: 1px solid rgba(222,222,222,1);
        .num{
            color: rgba(111, 111, 111, 1);
            font-weight: 700;
            margin-right: 15px;
        }
    }
    .el-dropdown-menu__item{
        position: relative;
        padding: 0;
        color: rgba(111, 111, 111, 1);
        font-size: 16px;
        line-height: 28px;
        padding: 10px 20px;
        margin: 10px 0;
        padding-left: 52px;
        .user-icon{
            position: absolute;
            left: 20px;
            top: 50%;
            margin-top: -10px;
            font-size: 20px;
            color: #606266;
        }
        .exit-icon{
            width: 20px;
            height: 20px;
            background: url('@/assets/images/exit.png') no-repeat;
            background-size: 20px 20px;
        }
        .dot{
            position: absolute;
            top: 15px;
            width: 8px;
            height: 8px;
            background-color: red;
            border-radius: 50%;
            margin-left: 4px;
        }
    }
}
.dropdown-active{
    color: #409EFF !important;
    background-color: #ecf5ff;
}
</style>